import useEntity from '../../hooks/useEntity'
import { useHistory, useParams } from 'react-router-dom'
import Loading from '../../components/Loading'
import * as React from 'react'
import NaturalPersonForm, { NaturalPersonMutationDto } from '../../components/Form/Party/NaturalPersonForm'
import useAxios from '../../hooks/useAxios'
import { sortTiers } from '../../components/Form/Tier/TierList'
import useUsers from '../../hooks/useUsers'
import useAttributes, { AttributeContextType, AttributeViewType, EntityAttributeType } from '../../hooks/useAttributes'

export default function EditNaturalPerson() {
    const axios = useAxios()
    const history = useHistory()
    const { id } = useParams<{ fileId?: string; id?: string }>()
    const users = useUsers()

    const attributes = useAttributes(AttributeViewType.Input, [AttributeContextType.NaturalPerson], undefined, EntityAttributeType.Party)

    const [entity] = useEntity<NaturalPersonMutationDto>(
        id => ({ url: `/party/${id}` }),
        id,
        response => ({
            ...response.data,
            tiers: sortTiers(users, response.data.tiers),
        }),
    )

    if (!entity.loaded) {
        return <Loading />
    }

    return (
        <NaturalPersonForm
            formikProps={{ initialValues: { addressCountry: 'NL', ...entity.data } }}
            onSubmit={(party: NaturalPersonMutationDto) => axios.put<string>(`/party/natural/${id}`, party)}
            goBack={() => history.goBack()}
            attributes={attributes}
        />
    )
}
